module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVAgMAAADUeU0FAAAACVBMVEUAAADt7e3t7e1JuSuAAAAAAnRSTlMAf7YpoZUAAAAxSURBVAjXJckhAcAwAASxl1aJFTGyqCw4FJCdbdtufPGHUqlUKpVKpVKpVCqVSiU4D2f6KLQalvIRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/sanjiao.png
// module id = avgF
// module chunks = 70